module.exports = __webpack_public_path__ + "static/media/chilicorn_logo_rgb.889b25d1.svg";